import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 16.901px;
  height: 14.16px;
  margin-right: 0.5rem;
`;

const TreeCollapseAllIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <path
        data-name="menu icon"
        d="M0 12.41a1.662 1.662 0 1 1 1.66 1.75A1.707 1.707 0 0 1 0 12.41zm5.987 1.038a1.034 1.034 0 1 1 0-2.065h9.823a1.034 1.034 0 1 1 0 2.065zM0 7.08a1.662 1.662 0 1 1 1.66 1.75A1.706 1.706 0 0 1 0 7.08zm5.987 1.032a1.034 1.034 0 1 1 0-2.065h9.823a1.034 1.034 0 1 1 0 2.065zM0 1.75a1.662 1.662 0 1 1 1.66 1.751A1.706 1.706 0 0 1 0 1.75zm5.987 1.028a1.034 1.034 0 1 1 0-2.065h9.823a1.034 1.034 0 1 1 0 2.065z"
        fill="#4694ce"
      />
    </Svg>
  );
};

export default TreeCollapseAllIcon;
